import React from 'react';
import ProcurementExcellenceLastPage from '../pages/lastpages/ProcurementExcellenceLastPage';
import DigitalMaturityLastPage from '../pages/lastpages/DigitalMaturityLastPage';
import SmartManufacturingLastPage from '../pages/lastpages/SmartManufacturingLastPage';
import ITLastPage from '../pages/lastpages/ITLastPage';
import ServiceExcellenceLastPage from '../pages/lastpages/ServiceExcellenceLastPage';
import DataScienceLastPage from '../pages/lastpages/DataScienceLastPage';
import ComplexityLastPage from '../pages/lastpages/ComplexityLastPage';
import DefaultLastPage from '../pages/lastpages/DefaultLastPage';
import { useLanguage } from './Localized';
import PlanningLastPage from '../pages/lastpages/PlanningLastPage';
import DataScienceAndAILastPage from '../pages/lastpages/DataScienceAndAILastPage';

/**
 * @brief Renders the last page depending on the survey id and the selected language.
 */
export const LastPage = ({ sid }) => {
    // currently we do not have any english translations for the last page - so we show the default page
    const lang = useLanguage();
    if (lang !== 'de') {
        return <DefaultLastPage />;
    }

    switch (sid) {
        case 341192: // procurement excellence
            return <ProcurementExcellenceLastPage />;
        case 933647: // digital maturity
            return <DigitalMaturityLastPage />;
        case 632377: // smart manufacturing
            return <SmartManufacturingLastPage />;
        case 274442: // IT
            return <ITLastPage />;
        case 869712: // service excellence
            return <ServiceExcellenceLastPage />;
        case 746749: // data science
            return <DataScienceLastPage />;
        case 945855: // complexity
            return <ComplexityLastPage />;
        case 696266: // service pricing
            return <ServiceExcellenceLastPage />;
        case 772366: // planning
            return <PlanningLastPage />;
        case 398727: // data science and AI
            return <DataScienceAndAILastPage />;
        default:
            return <DefaultLastPage />;
    }
};
